import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { Box, Stack, TextareaAutosize } from "@mui/material";
import QRcode from "assets/images/tca/1/QRcodeFU01RelapsePreventionPartI.png";
import CheckBox from "components/Checkbox";
import { useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import ReactToPrint from "react-to-print";

import VideoBlock from "../VideoBlock";
import YmcaPageHeader from "../YmcaPageHeader";

const StageFollowup01 = ({ sendContractToBackend }) => {
  const formContext = useFormContext();
  const { control, watch } = formContext;
  const watchFieldsToPrint = watch([
    "smsFollowUp01.troublesomeSituations01",
    "smsFollowUp01.troublesomeSituations02",
    "smsFollowUp01.troublesomeSituations03",
    "smsFollowUp01.troublesomeSituations04",
    "smsFollowUp01.troublesomeSituations05",
    "smsFollowUp01.troublesomeSituations06",
    "smsFollowUp01.troublesomeSituations07",
    "smsFollowUp01.troublesomeSituations08",
    "smsFollowUp01.troublesomeSituations09",
    "smsFollowUp01.troublesomeSituations10",
    "smsFollowUp01.troublesomeSituationsOthers",
    "smsFollowUp01.ideasForWorkaround",
  ]);
  const printTemplateRef = useRef();

  return (
    <>
      <Box className="greenContainer">
        <Box className="containerPadding">
          <Stack>
            <Box className="header1" mb={"20px"}>
              Follow Up Appointment 1
            </Box>
            <Box className="header2 green" mb={"16px"}>
              RELAPSE PREVENTION PART 1
            </Box>
          </Stack>
          <VideoBlock
            thumbnail="https://img.youtube.com/vi/O8qrRx-dwuE/maxresdefault.jpg"
            youtubeLink={
              "https://www.youtube.com/watch?v=O8qrRx-dwuE&list=PLgBxj8BHl0M33FtRIckAJCR0JEjqz2ujJ&index=6"
            }
          >
            <>
              <Box className="text text-bold video-title" mt={0.75} mb={2}>
                Watch this video about Relapse Prevention to get started!
              </Box>
              <Box className="text text-bold">
                Relapse Prevention is just as it sounds - relapsing back to sedentary ways. Everyone
                has different barriers to reaching our goals, but in order for us to be successful,
                it's important to identify some barriers or situations that could hinder your plan.
              </Box>
            </>
          </VideoBlock>
          <Box className="text text-bold" mb={2.5}>
            Let's get started identifying situations that could be troublesome. Go ahead and put a
            checkmark by any item below that could be a challenge for you.
          </Box>
          <Stack>
            <Controller
              name="smsFollowUp01.troublesomeSituations01"
              control={control}
              rules={{ required: false }}
              render={({ field: { onChange, value, ref } }) => (
                <CheckBox
                  isOrange={true}
                  checked={value}
                  onChange={onChange}
                  label={`Work commitments`}
                />
              )}
            />
            <Controller
              name="smsFollowUp01.troublesomeSituations02"
              control={control}
              rules={{ required: false }}
              render={({ field: { onChange, value, ref } }) => (
                <CheckBox
                  isOrange={true}
                  checked={value}
                  onChange={onChange}
                  label={`Childcare or other family responsibilities`}
                />
              )}
            />
            <Controller
              name="smsFollowUp01.troublesomeSituations03"
              control={control}
              rules={{ required: false }}
              render={({ field: { onChange, value, ref } }) => (
                <CheckBox
                  isOrange={true}
                  checked={value}
                  onChange={onChange}
                  label={`Having to travel for work or leisure`}
                />
              )}
            />
            <Controller
              name="smsFollowUp01.troublesomeSituations04"
              control={control}
              rules={{ required: false }}
              render={({ field: { onChange, value, ref } }) => (
                <CheckBox
                  isOrange={true}
                  checked={value}
                  onChange={onChange}
                  label={`Becoming bored with your exercise plan or routine`}
                />
              )}
            />
            <Controller
              name="smsFollowUp01.troublesomeSituations05"
              control={control}
              rules={{ required: false }}
              render={({ field: { onChange, value, ref } }) => (
                <CheckBox
                  isOrange={true}
                  checked={value}
                  onChange={onChange}
                  label={`Feeling discomfort while exercising`}
                />
              )}
            />
            <Controller
              name="smsFollowUp01.troublesomeSituations06"
              control={control}
              rules={{ required: false }}
              render={({ field: { onChange, value, ref } }) => (
                <CheckBox
                  isOrange={true}
                  checked={value}
                  onChange={onChange}
                  label={`Having to exercise alone`}
                />
              )}
            />
            <Controller
              name="smsFollowUp01.troublesomeSituations07"
              control={control}
              rules={{ required: false }}
              render={({ field: { onChange, value, ref } }) => (
                <CheckBox
                  isOrange={true}
                  checked={value}
                  onChange={onChange}
                  label={`Having to stop something more enjoyable to fit in your exercise`}
                />
              )}
            />
            <Controller
              name="smsFollowUp01.troublesomeSituations08"
              control={control}
              rules={{ required: false }}
              render={({ field: { onChange, value, ref } }) => (
                <CheckBox
                  isOrange={true}
                  checked={value}
                  onChange={onChange}
                  label={`Working out but not getting any encouragement or praise`}
                />
              )}
            />
            <Controller
              name="smsFollowUp01.troublesomeSituations09"
              control={control}
              rules={{ required: false }}
              render={({ field: { onChange, value, ref } }) => (
                <CheckBox
                  isOrange={true}
                  checked={value}
                  onChange={onChange}
                  label={`You feel self-conscious about the way you look while exercising`}
                />
              )}
            />
            <Controller
              name="smsFollowUp01.troublesomeSituations10"
              control={control}
              rules={{ required: false }}
              render={({ field: { onChange, value, ref } }) => (
                <CheckBox isOrange={true} checked={value} onChange={onChange} label={`Others?`} />
              )}
            />
            <Controller
              name="smsFollowUp01.troublesomeSituationsOthers"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <Stack spacing={1} mt={2} pl={"29px"} className="note-input-container">
                  <TextareaAutosize
                    {...field}
                    aria-label="description textarea"
                    className="note-textarea"
                    placeholder="Please enter"
                  />
                </Stack>
              )}
            />
          </Stack>
          <Box className="text text-bold" mt={2.5} mb={2}>
            Now let's come up with some work arounds! Here are a couple of things to remember:
          </Box>
          <Box className="text">
            <ol>
              <li>Any amount and type of exercise is better than none.</li>
              <li>
                Even though we love seeing you, we want you to be successful so remember that
                exercise doesn't always have to happen at the Y.
              </li>
            </ol>
          </Box>
          <Box className="text text-bold" mt={2.5} mb={2}>
            Ideas for work-arounds:
          </Box>
          <Controller
            name="smsFollowUp01.ideasForWorkaround"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <Stack spacing={1} mt={2} className="note-input-container">
                <TextareaAutosize
                  {...field}
                  aria-label="description textarea"
                  className="note-textarea"
                  placeholder="Please enter"
                />
              </Stack>
            )}
          />
        </Box>
        <hr className="containerDivider" />
        <Stack direction={"row"} justifyContent="space-around">
          <button type="button" className="action-button" onClick={() => sendContractToBackend()}>
            Email Document to the Member
          </button>
          <ReactToPrint
            trigger={() => (
              <button type="button" className="action-button">
                Print Document
              </button>
            )}
            content={() => printTemplateRef.current}
          />
        </Stack>
      </Box>
      <div className="out-of-sight">
        <Stack ref={printTemplateRef} className="elementToPrint">
          <YmcaPageHeader />
          <Stack direction={"row"} gap={2}>
            <img src={QRcode} width="114" height="114" />
            <Stack>
              <h1 style={{ color: "#00a98f" }}>RELAPSE PREVENTION PART 1</h1>
              <Box mb={2}>
                <p>Watch this video about Relapse Prevention to get started!</p>
              </Box>
              <Box>
                <p>
                  Relapse Prevention is just as it sounds - relapsing back to sedentary ways.
                  Everyone has different barriers to reaching our goals, but in order for us to be
                  successful, it's important to identify some barriers or situations that could
                  hinder your plan.
                </p>
              </Box>
            </Stack>
          </Stack>
          <Stack>
            <Box my={2}>
              <p>
                Let's get started identifying situations that could be troublesome. Go ahead and put
                a checkmark by any item below that could be a challenge for you.
              </p>
            </Box>
            <Stack direction={"row"} gap={1}>
              {watchFieldsToPrint[0] ? <TaskAltIcon /> : <RadioButtonUncheckedIcon />}
              1. Work Commitments
            </Stack>
            <Stack direction={"row"} gap={1}>
              {watchFieldsToPrint[1] ? <TaskAltIcon /> : <RadioButtonUncheckedIcon />}
              2. Childcare or other family responsibilities
            </Stack>
            <Stack direction={"row"} gap={1}>
              {watchFieldsToPrint[2] ? <TaskAltIcon /> : <RadioButtonUncheckedIcon />}
              3. Having to travel for work or leisure
            </Stack>
            <Stack direction={"row"} gap={1}>
              {watchFieldsToPrint[3] ? <TaskAltIcon /> : <RadioButtonUncheckedIcon />}
              4. Becoming bored with your exercise plan or routine
            </Stack>
            <Stack direction={"row"} gap={1}>
              {watchFieldsToPrint[4] ? <TaskAltIcon /> : <RadioButtonUncheckedIcon />}
              5. Feeling discomfort while exercising
            </Stack>
            <Stack direction={"row"} gap={1}>
              {watchFieldsToPrint[5] ? <TaskAltIcon /> : <RadioButtonUncheckedIcon />}
              6. Having to exercise alone
            </Stack>
            <Stack direction={"row"} gap={1}>
              {watchFieldsToPrint[6] ? <TaskAltIcon /> : <RadioButtonUncheckedIcon />}
              7. Having to stop something more enjoyable to fit in your exercise
            </Stack>
            <Stack direction={"row"} gap={1}>
              {watchFieldsToPrint[7] ? <TaskAltIcon /> : <RadioButtonUncheckedIcon />}
              8. Working out but not getting any encouragement or praise
            </Stack>
            <Stack direction={"row"} gap={1}>
              {watchFieldsToPrint[8] ? <TaskAltIcon /> : <RadioButtonUncheckedIcon />}
              9. You feel self-conscious about the way you look while exercising
            </Stack>
            <Stack direction={"row"} gap={1}>
              {watchFieldsToPrint[9] ? <TaskAltIcon /> : <RadioButtonUncheckedIcon />}
              10. Others
            </Stack>
            {watchFieldsToPrint[9] && watchFieldsToPrint[10] && (
              <Box
                className="filledFormField p_wrap"
                mt={2}
                style={{
                  background: "#edf6ff",
                  border: "dotted 1px #313a3d",
                  padding: "10px",
                  whiteSpace: "pre-line",
                }}
              >
                {watchFieldsToPrint[10]}
              </Box>
            )}
            <Box className="text text-bold" mt={2.5} mb={2}>
              Now let's come up with some work arounds! Here are a couple of things to remember:
            </Box>
            <div style={{ backgroundColor: "yellow", marginLeft: "16px" }}>
              1. Any amount and type of exercise is better than none.
            </div>
            <div style={{ backgroundColor: "yellow", marginLeft: "16px" }}>
              2. Even though we love seeing you, we want you to be successful so remember that
              exercise doesn't always have to happen at the Y.
            </div>
            <Box className="text text-bold" mt={2.5} mb={2}>
              Ideas for work-arounds:
            </Box>
            <Box
              className="filledFormField p_wrap"
              mt={2}
              style={{
                background: "#edf6ff",
                border: "dotted 1px #313a3d",
                padding: "10px",
                whiteSpace: "pre-line",
              }}
            >
              {watchFieldsToPrint[11]}
            </Box>
          </Stack>
        </Stack>
      </div>
    </>
  );
};

export default StageFollowup01;
